import React from "react";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Typography from "@mui/material/Typography";
import dayjs from "dayjs";

import SVG from "@/assets/svg";
import CostumeButton from "@/component/button";
import VisitLayout from "../visit-info/visit";

interface ISaveChange {
  visitTime: Date | null | undefined;
  isPastVisit: boolean;
  loading: boolean;
  onClose: () => void;
  handleSave: (val: boolean) => void;
  warningMsg?: string;
}

function SaveChange({
  visitTime,
  isPastVisit,
  loading,
  onClose,
  handleSave,
  warningMsg,
}: ISaveChange) {
  const [changeAll, setChangeAll] = React.useState(false);
  return (
    <>
      <div>
        <VisitLayout>
          <Box className="Add-medication">
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "19px",
              }}
            >
              <Typography id="modal-modal-title" variant="h3">
                Save changes to the visit plan
              </Typography>
              <Box onClick={onClose}>
                <SVG.Cross />
              </Box>
            </Box>
            {warningMsg && (
              <Alert severity="warning" variant="filled" sx={{ mb: 2 }}>
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: 600,
                  }}
                >
                  Warning
                </Typography>
                <Typography variant="body2">{warningMsg}</Typography>
              </Alert>
            )}
            <Box>
              {dayjs(visitTime).isAfter(dayjs()) && (
                <Grid
                  className="personal"
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <Alert
                    severity="warning"
                    color="error"
                    sx={{
                      lineHeight: "21px",
                    }}
                  >
                    This visit may already have started. Edits you make may not
                    show in the app, as the care team could be out of signal.
                  </Alert>
                </Grid>
              )}
              <Grid
                className="personal"
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <Box className="medicationViewList">
                  <RadioGroup
                    value={changeAll}
                    onChange={(e) => setChangeAll(e.target.value === "true")}
                  >
                    <FormControlLabel
                      value={"true"}
                      disabled={isPastVisit}
                      control={<Radio />}
                      label="Apply to all future visits"
                    />
                    <Typography className="required">
                      {isPastVisit
                        ? "This option is unavailable because the visit is in the past."
                        : "Changes will be made to all upcoming visits."}
                    </Typography>
                    <FormControlLabel
                      value={"false"}
                      control={<Radio />}
                      label="Apply to this visit only"
                    />
                    <Typography className="required">
                      Changes will be made to the{" "}
                      {dayjs(visitTime)
                        .subtract(dayjs(visitTime).utcOffset(), "minutes")
                        .format("HH:mm")}{" "}
                      visit on {dayjs(visitTime).format("dddd DD MMMM")}
                    </Typography>
                  </RadioGroup>
                </Box>
              </Grid>
              <Box
                sx={{ display: "flex", width: "100%", justifyContent: "end" }}
              >
                <CostumeButton onClick={onClose} className="cancel">
                  Cancel
                </CostumeButton>
                <CostumeButton
                  loading={loading}
                  onClick={() => handleSave(changeAll)}
                  className="invite"
                  sx={{ width: " 120px" }}
                >
                  Save
                </CostumeButton>
              </Box>
            </Box>
          </Box>
        </VisitLayout>
      </div>
    </>
  );
}

export default SaveChange;
